'use strict';

// https://snazzymaps.com/style/53/flat-map
module.exports = [{ featureType: 'all', elementType: 'labels', stylers: [{ visibility: 'off' }] }, {
	featureType: 'landscape',
	elementType: 'all',
	stylers: [{ visibility: 'on' }, { color: '#f3f4f4' }]
}, {
	featureType: 'landscape.man_made',
	elementType: 'geometry',
	stylers: [{ weight: 0.9 }, { visibility: 'off' }]
}, {
	featureType: 'poi.park',
	elementType: 'geometry.fill',
	stylers: [{ visibility: 'on' }, { color: '#83cead' }]
}, {
	featureType: 'road',
	elementType: 'all',
	stylers: [{ visibility: 'on' }, { color: '#ffffff' }]
}, { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] }, {
	featureType: 'road.highway',
	elementType: 'all',
	stylers: [{ visibility: 'on' }, { color: '#fee379' }]
}, {
	featureType: 'road.arterial',
	elementType: 'all',
	stylers: [{ visibility: 'on' }, { color: '#fee379' }]
}, {
	featureType: 'water',
	elementType: 'all',
	stylers: [{ visibility: 'on' }, { color: '#7fc8ed' }]
}];